module.exports = __webpack_public_path__ + "img/docs.c6c46b2e.svg";